<h1 matDialogTitle>{{ data.title }}</h1>
<div mat-dialog-content>
  <mat-card class="p-0">
    <form [formGroup]="produtoForm" (keydown.enter)="$event.preventDefault()">
      <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px" class="form-container">
        <!-- Código de Barras 1 -->
        <div fxFlex="50" fxFlex.lt-md="100" fxFlex.sm="50">
          <mat-form-field class="full-width">
            <mat-label>Código de Barras Nº 1</mat-label>
            <input
              [imask]="maskCodigoBarra"
              matInput
              name="codigobarra1"
              type="text"
              [formControl]="produtoForm?.controls['codigobarra1']!"
            />
          </mat-form-field>
          <!-- <ngx-barcode6 [bc-height]="40" [bc-format]="'EAN13'" [bc-value]="produtoForm?.controls['codigobarra1']?.value || ''" [bc-display-value]="true"></ngx-barcode6> -->
        </div>

        <!-- Código de Barras 2 -->
        <div fxFlex="50" fxFlex.lt-md="100" fxFlex.sm="50">
          <mat-form-field class="full-width">
            <mat-label>Código de Barras Nº 2</mat-label>
            <input
              [imask]="maskCodigoBarra"
              matInput
              name="codigobarra2"
              type="text"
              [formControl]="produtoForm?.controls['codigobarra2']!"
            />
          </mat-form-field>
          <!-- <ngx-barcode6 [bc-height]="40" [bc-format]="'EAN13'" [bc-value]="produtoForm?.controls['codigobarra2']?.value || ''" [bc-display-value]="true"></ngx-barcode6> -->
        </div>

        <!-- Código de Barras 3 -->
        <div fxFlex="50" fxFlex.lt-md="100" fxFlex.sm="50">
          <mat-form-field class="full-width">
            <mat-label>Código de Barras Nº 3</mat-label>
            <input
              [imask]="maskCodigoBarra"
              matInput
              name="codigobarra3"
              type="text"
              [formControl]="produtoForm?.controls['codigobarra3']!"
            />
          </mat-form-field>
          <!-- <ngx-barcode6 [bc-height]="40" [bc-format]="'EAN13'" [bc-value]="produtoForm?.controls['codigobarra3']?.value || ''" [bc-display-value]="true"></ngx-barcode6> -->
        </div>

        <!-- Código de Barras 4 -->
        <div fxFlex="50" fxFlex.lt-md="100" fxFlex.sm="50">
          <mat-form-field class="full-width">
            <mat-label>Código de Barras Nº 4</mat-label>
            <input
              [imask]="maskCodigoBarra"
              matInput
              name="codigobarra4"
              type="text"
              [formControl]="produtoForm?.controls['codigobarra4']!"
            />
          </mat-form-field>
          <!-- <ngx-barcode6 [bc-height]="40" [bc-format]="'EAN13'" [bc-value]="produtoForm?.controls['codigobarra4']?.value || ''" [bc-display-value]="true"></ngx-barcode6> -->
        </div>
      </div>
    </form>
  </mat-card>
</div>
<mat-dialog-actions>
  <div fxFlex="100" class="action-buttons">
    <button
      mat-raised-button
      color="primary"
      [matTooltip]="'Salvar Lançamento'"
      (click)="this.save(); $event.preventDefault()"
    >
      <mat-icon>save</mat-icon> {{ "SAVE" | translate }}
    </button>
    <span fxFlex></span>
    <button mat-button color="warn" type="button" (click)="close()">
      <mat-icon>close</mat-icon> {{ "CLOSE" | translate }}
    </button>
  </div>
</mat-dialog-actions>